module.exports = __webpack_public_path__ + "img/rindfleischganbianohnehintergrund.221af737.png";